import { Controller } from "@hotwired/stimulus";

// 行全体をクリッカブルにする。クリック時、data-row-link-url-value で指定された URL を
// reward-modal-frame の Turbo Frame にロードする。
// リンク/ボタン/フォーム要素上のクリックは本来のアクションを優先するため無視する。
export class RowLinkController extends Controller {
  static values = { url: String };

  open(event) {
    if (event.target.closest("a, button, form, input, label")) return;

    const frame = document.getElementById("reward-modal-frame");
    if (!frame) return;

    frame.src = this.urlValue;
  }
}
